module.exports = __webpack_public_path__ + "static/media/ar.pictogram.a529721d.svg";